import type { ApiResponse } from '@/shared/model/types/http';

export function unwrapData<T>(response: ApiResponse<T> | null | undefined): T | null;
export function unwrapData(response: unknown): unknown;
export function unwrapData(response: unknown): unknown {
  if (typeof response === 'object' && response !== null && 'data' in response) {
    return response.data;
  }
  return null;
}

export function extractList<T>(response: unknown): T[] {
  const data = unwrapData(response);
  return Array.isArray(data) ? data : [];
}

export default unwrapData;
